export class Carrier {
    id: number;
    name: string;
    code: string;

    constructor() {
        this.id = 0;
        this.name = null;
        this.code = null;
    }
}

export class CarrierPayload {
    carrierID: number;
    companyID: number;
    includeDisabled: boolean;

    constructor() {
        this.carrierID = 0;
        this.companyID = 0;
        this.includeDisabled = false;
    }
}